export class CameraPositionLimiter {
    constructor() {
        this.phiMin = CameraPositionLimiter.EPS;
        this.phiMax = Math.PI - CameraPositionLimiter.EPS;
        this.thetaMin = undefined;
        this.thetaMax = undefined;
        this.rMax = Number.MAX_VALUE;
        this.rMin = CameraPositionLimiter.EPS;
    }
    setLimit(type, max, min) {
        switch (type) {
            case "phi":
                this.phiMax = max;
                this.phiMin = min;
                break;
            case "theta":
                this.thetaMax = max;
                this.thetaMin = min;
                break;
            case "radius":
                this.rMax = max;
                this.rMin = min;
                break;
        }
    }
    clampWithType(type, val) {
        switch (type) {
            case "phi":
                return CameraPositionLimiter.clamp(val, this.phiMax, this.phiMin);
            case "theta":
                return CameraPositionLimiter.clamp(val, this.thetaMax, this.thetaMin);
            case "radius":
                return CameraPositionLimiter.clamp(val, this.rMax, this.rMin);
        }
        return val;
    }
    clampPosition(type, pos) {
        const val = pos[type];
        pos[type] = this.clampWithType(type, val);
    }
    static clamp(value, max, min) {
        if (min == null || max == null)
            return value;
        value = Math.min(value, max);
        value = Math.max(value, min);
        return value;
    }
}
CameraPositionLimiter.EPS = 0.000001;
